import { render, staticRenderFns } from "./design-expend-table.vue?vue&type=template&id=dc190064&scoped=true"
import script from "./design-expend-table.vue?vue&type=script&lang=js"
export * from "./design-expend-table.vue?vue&type=script&lang=js"
import style0 from "./design-expend-table.vue?vue&type=style&index=0&id=dc190064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc190064",
  null
  
)

export default component.exports